import content from "app-content";
import {
  LOW_IN_STOCK,
  OUT_OF_STOCK,
  COLOUR_OUT_OF_STOCK,
  SIZE_OUT_OF_STOCK,
  COLOUR_OR_SIZE_OUT_OF_STOCK,
  RESTOCKING_SOON
} from "./stockConstants";

const stockStatusMap = {
  [OUT_OF_STOCK]: content.saved_items_item_product_oos,
  [LOW_IN_STOCK]: content.saved_items_low_in_stock_label,
  [COLOUR_OUT_OF_STOCK]: content.saved_items_colour_out_of_stock,
  [SIZE_OUT_OF_STOCK]: content.saved_items_size_out_of_stock,
  [COLOUR_OR_SIZE_OUT_OF_STOCK]: content.saved_items_size_colour_out_of_stock,
  [RESTOCKING_SOON]: content.back_in_stock_soon_label
};

export default stockStatus => stockStatusMap[stockStatus];
